import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
export function isObject(obj) {
  return _typeof(obj) === 'object' && obj !== null && !_Array$isArray(obj);
}
export function isPromise(obj) {
  return isObject(obj) && typeof obj.then === 'function';
}
var counter = 0;
export function uuid(a) {
  return process.env.NODE_ENV === 'test' ? "uuid-".concat(++counter) : a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
}